__turbopack_context__.v({
  "hideOnRowHoverHelper": "tableWrapper-module-scss-module__L66h0a__hideOnRowHoverHelper",
  "showOnRowHoverHelper": "tableWrapper-module-scss-module__L66h0a__showOnRowHoverHelper",
  "tableWrapperContainer": "tableWrapper-module-scss-module__L66h0a__tableWrapperContainer",
  "tableWrapperContent": "tableWrapper-module-scss-module__L66h0a__tableWrapperContent",
});
